module.exports = __webpack_public_path__ + "static/media/posture3.35934896.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/posture3.jpg
// module id = 197
// module chunks = 0